var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { mapGetters } from 'vuex';
import { FRANCHISOR, LOCATION } from '@/stores/defs';
var footerMixin = {
    computed: __assign({}, mapGetters({
        franchisor: FRANCHISOR.GET_FRANCHISOR,
        storeLocation: LOCATION.GET_LOCATION
    })),
    methods: {
        logoLoaded: function (data) {
            var container = this.$el;
            var image = data.currentTarget;
            var height = image.naturalHeight;
            var width = image.naturalWidth;
            var ratio = width / height;
            if (ratio > 1) {
                container.classList.add('wide-logo');
                return;
            }
            container.classList.add('tall-logo');
        },
    },
    data: function () {
        return {
            currentYear: (new Date()).getFullYear(),
        };
    },
};
export default footerMixin;



//////////////////
// WEBPACK FOOTER
// ./src/components/mixins/footerMixin.ts
// module id = wEzS
// module chunks = 18